export default {
    //@ts-ignore
    bind(el) {
      el.addEventListener('input', () => {
        let value = el.value;
        // Remove non-digit characters
        value = value.replace(/\D/g, '');
        // Update the input value
        el.value = value;        
      });
    }
  };